import { z } from "zod";

export const DeploymentFuelBrandItemSchema = z.object({
  Id: z.string(),
  Name: z.string(),
});

export type DeploymentFuelBrandItemType = z.infer<
  typeof DeploymentFuelBrandItemSchema
>;
